var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "46_My-playlist",
    transform: "translate(-1240, -286)",
    fill: "#CFDAE6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_download",
    transform: "translate(1240, 286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.508798,10.5102639 C15.7808914,10.5102639 16.001466,10.7308392 16.001466,11.0029326 L16.001466,14.0058651 C16.001466,15.1071954 15.1086613,16 14.007331,16 L1.9941349,16 C0.892804604,16 0,15.1071954 0,14.0058651 L0,11.0029326 C0,10.7308392 0.220575255,10.5102639 0.492668622,10.5102639 C0.764761988,10.5102639 0.985337243,10.7308392 0.985337243,11.0029326 L0.985337243,14.0058651 C0.985337243,14.5630087 1.43699134,15.0146628 1.9941349,15.0146628 L14.007331,15.0146628 C14.5644746,15.0146628 15.016129,14.5630087 15.016129,14.0058651 L15.016129,11.0029326 C15.016129,10.7308392 15.2367046,10.5102639 15.508798,10.5102639 Z M7.94797968,0 C8.22007304,0 8.4406483,0.220575255 8.4406483,0.492668622 L8.4406483,11.4793132 L8.8597789,11.1445048 L11.3972569,9.11752531 C11.5486073,8.97586974 11.7442686,8.93526034 11.919185,8.99856978 C12.0941013,9.06187923 12.2184451,9.21831167 12.2406566,9.40300184 C12.2628682,9.58769201 12.1791599,9.76914559 12.0242418,9.87212221 L12.0058883,9.88552359 L8.2522226,12.8884561 C8.0743764,13.028986 7.82158296,13.028986 7.64252513,12.8874928 L3.89007107,9.88552359 C3.71991918,9.72372537 3.69928385,9.43485946 3.8585088,9.2345442 C4.01773375,9.03422894 4.3038069,8.98915695 4.51691041,9.13081034 L7.03618046,11.1445048 L7.45531106,11.4793132 L7.45531106,0.492668622 C7.45531106,0.220575255 7.67588631,0 7.94797968,0 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic_download.055ef9ef859d5ca9dc298009d5042ecb.svg";
export { ForwardRef as ReactComponent };